/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-item',['require','jquery','underscore','core/engine','screens/scenario-mapper/scenario-asset','screens/scenario-mapper/scenario-utils'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  //var Scenario = require('screens/scenario-mapper/scenario');
  var Engine = require('core/engine');
  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');
  var ScenarioUtils = require('screens/scenario-mapper/scenario-utils');

  /*****************************************************************************************************************///}

  var ScenarioItem = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    name: null,
    imagePath: null,
    description: null,
    purpose: null,
    inSection: false,
    current: 0,
    isPresent: true,
    convoID: null,
    mcName: null,
    mcAsset: null,
    multiAsset: false,
    activePlayingMC: null,
    frameNameStr: 'default',
    lastFrameNameStr: 'default',
    mcImg: null,
    channel: null,
    checkInt: null,

    hasIdleFrame: false,
    isMouth: false,
    mouthData: null,
    mouthArr: null,
    mouthEl: null,
    loadFail: false,

    playingFeedbackFrames: false,
    frameCompleteCallback: null,

    dialog: null,
    isReady: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      ScenarioItem.instancesArr.push(this);
      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    mapAssetMC: function()
    {
      var $mc;
      var $convo;
      var $assetArr = this.convoID.split(',');
      //console.log('map asset');
      if ($assetArr.length > 1)
      {
        this.multiAsset = true;
      }
      else
      {
        if (!this.mcAsset)
        {
          $convo = Scenario.getConversationByID(this.convoID);
          if ($convo && $convo.bg)
          {
            $mc = ScenarioUtils.findAssetInContainer(this.mcName, $convo.bg);
            if ($mc)
            {
              this.mcAsset = $mc;
            }
          }
          else
          {
            console.warn('no convo or convobg found');
          }
        }

        if (this.mcAsset)
        {
          //this.hasIdleFrame = ScenarioUtils.mcHasLabel(this.mcAsset, 'idle');
          if (this.mcAsset.find('img').length === 0)
          {
            if (this.mcAsset.find('> [data-mc=image-container]').length > 0)
            {
              if (this.mcAsset.find('> [data-mc=image-container]').hasClass('mouth-parts'))
              {
                this.mouthEl = this.mcAsset.find('> [data-mc=image-container]');
                this.isMouth = true;
              }

              this.mcAsset.find('> [data-mc=image-container]').append(this.mcImg);
            }
            else
            {
              if (this.mcAsset.hasClass('mouth-parts'))
              {
                this.mouthEl = this.mcAsset;
                this.isMouth = true;
              }

              this.mcAsset.append(this.mcImg);
            }
          }
          this.mcAsset.addClass('hw-accel');
        }
        else
        {
          //console.error('ScenarioItem Asset not found: ' + this.mcName + ' in convoID: ' + this.convoID);
          ScenarioItem.assetMapErrorArr.push({'Missing Asset Name': this.mcName, 'ConvoID': this.convoID});
        }
      }
    },

    frameName: function($frameNameStr)
    {
      ////console.log('set frame', $frameNameStr, this.mcAsset);
      this.lastFrameNameStr = this.frameNameStr;
      this.frameNameStr = $frameNameStr;
    },

    updateFrames: function()
    {
      //var $mc;
      //var $convo;
      var $playFrame = false;

      if (this.playingFeedbackFrames && this.frameCompleteCallback !== null)
      {
        //console.log('Not updating frame, currently playing feedbackframes');
      }
      else if (this.mcAsset)
      {
        if (this.playingFeedbackFrames)
        {
          if (this.mcAsset.attr('data-frame') === this.frameNameStr)
          {
            return;
          }
          this.framesComplete();
        }

        if (this.mcAsset.dialog && !this.dialog)
        {
          this.dialog = this.mcAsset.data().dialog;
        }
        if (this.dialog)
        {
          this.isPresent = this.dialog.getAvailable();
        }

        if (this.isPresent)
          this.mcAsset.show();
        else
          this.mcAsset.hide();

        if (this.frameNameStr.indexOf('*') !== -1)
        {
          $playFrame = true;
          this.frameNameStr = this.frameNameStr.replace('*', '');
        }
        if (ScenarioUtils.mcHasLabel(this.mcAsset, this.frameNameStr))
        {
          if ($playFrame)
          {
            this.playFrame(this.frameNameStr);
          }
          else
          {
            this.mcAsset.attr('data-frame', this.frameNameStr);
          }
        }
        else
        {
          console.error('Unable to update frames for item: ' + this.name + ' => Requested frame: ' + this.frameNameStr);
        }
      }
      else
      {
        //console.error('ScenarioItem Asset not found: ' + this.mcName + ' in convoID: ' + this.convoID);
      }
    },

    skipFrames: function()
    {
      if (this.activePlayingMC)
      {
        this.activePlayingMC.off('feedback.complete', $.proxy(this.framesComplete, this));
        this.activePlayingMC.trigger('feedback.stop');
      }
      if (this.channel)
        this.channel.stop();
      else
        this.framesComplete();
    },

    pause: function()
    {
      if (this.activePlayingMC)
      {
        this.activePlayingMC.stop();
      }
    },

    resume: function()
    {
      if (this.activePlayingMC)
      {
        this.activePlayingMC.play();
      }
    },

    playFrame: function($frameName, $completeCallback)
    {
      $completeCallback = ($completeCallback === undefined) ? null : $completeCallback;

      //var $childMC;
      //console.log('PLAY FEEDBACK FRAME: ', $frameName, this.mcAsset);
      this.frameCompleteCallback = $completeCallback;

      if (!this.mcAsset || !ScenarioUtils.mcHasLabel(this.mcAsset, $frameName))
      {
        console.error('Unable to play feedback frames. (asset, frame): ' + this.mcAsset + ', ' + $frameName);
        this.framesComplete();
      }
      else
      {
        this.mcAsset.attr('data-frame', $frameName);
        this.activePlayingMC = this.mcAsset;//this.mcAsset.getChildByName($frameName + '_mc');
        if (this.activePlayingMC)
        {
          this.playingFeedbackFrames = true;

          switch ($frameName)
          {
            case 'shock':
              _.delay($.proxy(this.framesComplete, this), 250);
              break;
            default:
              this.mcAsset.one('feedback.complete', $.proxy(this.framesComplete, this));
              this.mcAsset.trigger('feedback.start.' + $frameName, [Engine.module('Media'), this]);
              //_.delay($.proxy(this.framesComplete, this), 500);
              break;
          }
          //this.activePlayingMC.addEventListener(Event.ENTER_FRAME, this.onFrameHandler, false, 0, true);
        }
        else
        {
          console.error('Unable to play feedback frames. Missing child MC with name: ' + $frameName + '_mc');
          this.framesComplete();
        }
      }
    },

    startItemAnimation: function(filename, $ele, timeStamps, $finalAction)
    {
      //console.log('start item animation');
      this.channel = Engine.module('Media').itemChannel;
      this.channel.play(filename, {controls: false});
      this.channel.once($.jPlayer.event.ended, $.proxy(this.framesComplete, this, $finalAction));
      this.checkInt = setInterval($.proxy(this.checkChannelStatus, this, $ele, timeStamps), 25);
    },

    checkChannelStatus: function($ele, timeStamps)
    {
      var $audioDiv = this.channel.player[0].getElementsByTagName('audio');
      var $curTime = 0;
      if ($audioDiv.length > 0)
        $curTime = this.channel.player[0].getElementsByTagName('audio')[0].currentTime;
      else
        $curTime = this.channel.player.data().jPlayer.status.currentTime;

      $curTime = $curTime * 1000;
      ////console.log('sItem time:', $curTime);
      var matchObj = timeStamps[0];
      _.each(timeStamps, function(stamp) {
        if ($curTime <= stamp.time)
        {
          ////console.log('found', stamp);
          return false;
        }
        matchObj = stamp;
      });
      ////console.log('apply', matchObj);
      matchObj.action.apply($ele, matchObj.args);
      ////console.log('interval done');
    },

    onFrameHandler: function($e)
    {
      var $curTime = $e.jPlayer.status.currentTime;//$that.channel.currentTime;
      var $frameRate = 20;
      var $curFrame = Math.round($curTime * $frameRate);
      if (this.mouthArr && this.mouthEl)
      {
        //console.log('mouth', this.mouthArr[$curFrame]);
        this.mouthEl.attr('data-mouth', this.mouthArr[$curFrame]);
      }
    },

    checkChildFrames: function($mc)
    {
      if ($mc.currentFrame === $mc.totalFrames)
      {
        this.framesComplete();
      }
    },

    framesComplete: function($finalAction)
    {
      //console.log('Frames complete, set back');
      clearInterval(this.checkInt);

      if ($finalAction)
        $finalAction();

      if (this.mcAsset)
        this.mcAsset.off('feedback.complete');

      if (this.channel)
        this.channel.cleanup();

      if (this.activePlayingMC)
      {
        //this.activePlayingMC.removeEventListener(Event.ENTER_FRAME, this.onFrameHandler);
        //this.activePlayingMC.stop();
      }

      this.playingFeedbackFrames = false;

      //this.mcAsset.trigger('feedback.complete');

      /*if (this.hasIdleFrame)
      {
        //console.log('returning to idle');
        this.frameNameStr = 'idle';
        this.updateFrames();
      }
      else*/
      var $revertArr = ['shock'];
      if (this.lastFrameNameStr && $.inArray(this.frameNameStr, $revertArr) !== -1)
      {
        ////console.log('returning to ', this.lastFrameNameStr, this);
        this.frameNameStr = this.lastFrameNameStr;
        this.lastFrameNameStr = null;
        this.updateFrames();
      }

      if (this.frameCompleteCallback !== null)
      {
        this.frameCompleteCallback();
        //this.frameCompleteCallback = null;
      }
    },

    getTimeTotal: function()
    {
      if (this.activePlayingMC)
      {
        return this.activePlayingMC.totalFrames;
      }
      return 0;
    },

    getTimeCurrent: function()
    {
      if (this.activePlayingMC)
      {
        return this.activePlayingMC.currentFrame;
      }
      return 0;
    },

    getTimePerc: function()
    {
      return (this.timeTotal > 0) ? (this.timeCurrent / this.timeTotal) : 0;
    },

    onBeforeDestroy: function()
    {
      this.frameCompleteCallback = null;
      this.framesComplete();
      this.activePlayingMC = null;
      this.mcAsset = null;
      this.dialog = null;
    },

    parseData: function(data)
    {
      ScenarioAsset.prototype.parseData.apply(this, arguments);

      this.saType = ScenarioAsset.SA_TYPE_ITEM;

      this.name = data.Fields.Name;
      this.imagePath = 'graphics/' + data.Fields.Pictures;
      this.description = data.Fields.Description;
      this.purpose = data.Fields.Purpose;
      this.inSection = (data.Fields.inSection === 'True');
      this.current = Number(data.Fields.current);

      if ('convoId' in data.Fields)
      {
        this.convoID = data.Fields.convoId;
      }
      else
      {
        console.error('convoId missing from Item, verify property spelling and value in chatmapper');
      }
      this.mcName = data.Fields.mcName;
      this.frameName(data.Fields.frameName);

      this.hasIdleFrame = false;
      if (this.frameNameStr === 'idle')
        this.hasIdleFrame = true;

      this.isPresent = ScenarioUtils.getValue(data.Fields.isPresent);
      this.loadFail = false;

      //this.mapAssetMC();

      if (this.description.indexOf('noimage') === -1)
      {
        var $ext = (this.description === 'usejpg') ? '.jpg' : '.png';
        var $pathStr = Scenario.getConversationByID(this.convoID).bgImageName.replace('.swf', '') + '_' + this.mcName + $ext;
        this.imagePath = 'content/graphics/' + $pathStr;
        var $mcImg = $('<img>').addClass('mc-image');
        $mcImg.on('load', $.proxy(this.onIMGLoadedHandler, this, $mcImg));
        $mcImg.on('error', $.proxy(this.onIMGLoadedHandler, this, $mcImg, false));
        $mcImg.attr('src', this.imagePath);
        this.mcImg = $mcImg;
      }
      else
      {
        this.ready();
      }
    },

    onIMGLoadedHandler: function($img, $success)
    {
      $success = ($success === undefined) ? true : $success;

      if ($success)
      {
        //this.mcImg = $img;
        //add image to convo view $bgMC
        if (this.loadFail === true)
          //console.log('retry successful', $img.attr('src'));

        $img.off('load');
        $img.off('error');
        this.ready();
      }
      else if (this.loadFail === false)
      {
        console.error('MC Item Img not found, trying backup: ', $img.attr('src'));
        this.loadFail = true;
        $img.attr('src', 'content/graphics/' + this.mcName + '.png');
      }
      else
      {
        console.error('MC Item Img not found: ', $img.attr('src'));
        $img.off('load');
        $img.off('error');
        this.ready();
      }
    },

    ready: function()
    {
      this.isReady = true;
      this.trigger(Scenario.ITEM_READY, this);
    }

  /*****************************************************************************************************************///}

  });

  ScenarioItem.instancesArr = [];
  ScenarioItem.assetMapErrorArr = [];

  ScenarioItem.destroy = function()
  {
    _.each(ScenarioItem.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioItem.instancesArr = [];
    ScenarioItem.assetMapErrorArr = [];
  };

  ScenarioItem.mapItems = function()
  {
    _.each(ScenarioItem.instancesArr, function($item) {
      $item.mapAssetMC();
    });
  };

  ScenarioItem.updateItemFrames = function()
  {
    _.each(ScenarioItem.instancesArr, function($item) {
      $item.updateFrames();
    });
  };

  return ScenarioItem;

});

